//  @flow
import * as React from "react";

import { Tabs, Tab, Container } from '@mui/material';
import { useLocation, useHistory } from 'react-router-dom';
import { Box } from '@mui/system';

import WholesaleHeaderNav from "components/elements/main/WholesaleHeaderNav";
import WholesaleUserProductsPageSearch from "components/pages/seller/wholesale/WholesaleUserProductsPageSearch";
import WholesaleUserShopsPageSearch from "components/pages/seller/wholesale/WholesaleUserShopsPageSearch";
import WholesaleUserOrderList from "components/pages/seller/wholesale/WholesaleUserOrderList";

import "./styles.scss";

const tabs = [
  { label: 'Products', path: '/products' },
  { label: 'Shops', path: '/shops' },
    { label: 'Orders', path: '/orders' }
];

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

const WholeSaleMain = (props) => {

  const location = useLocation();
  const history = useHistory();
  const currentTab = tabs.findIndex(tab => location.pathname.startsWith(tab.path));

  const handleChange = (event, newValue) => {
    history.push(tabs[newValue].path);
  };

  return (
      <Container>
          <WholesaleHeaderNav {...props} />
    <Box sx={{ width: "100%" }}>
        <Box mt={2} mb={2} sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs value={currentTab}
                sx={{
                    '& .MuiTab-root': {
                        backgroundColor: 'grey.300',
                        color: 'black',
                    },
                    '& .Mui-selected': {
                        backgroundColor: "primary.100",
                        color: 'white !important',
                    },
                }}
                variant="fullWidth"
                aria-label=""
                onChange={handleChange}>
            {tabs.map((tab, index) => (
                <Tab key={index} label={tab.label} {...a11yProps(index)} />
            ))}
          </Tabs>
        </Box>

        {location.pathname.startsWith('/products') && (
            <WholesaleUserProductsPageSearch {...props} />
        )}
        {location.pathname.startsWith('/shops') && (
            <WholesaleUserShopsPageSearch {...props} />
        )}
        {location.pathname.startsWith('/orders') && (
            <WholesaleUserOrderList {...props} />
        )}
      </Box>
      </Container>
  );
};


export default (WholeSaleMain);
